/* eslint-disable import/no-default-export */
import React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'app/gamma/src/types';

import { LayerManagerPortal, Layers } from 'app/src/components/LayerManager';
import { removeOverlay } from 'app/gamma/src/modules/state/ui/overlay';

import { Overlay } from './overlay';
import { OwnProps, AllProps, DispatchProps } from './types';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

class OverlayContainerUnconnected extends React.Component<AllProps> {
  render() {
    return (
      <LayerManagerPortal layer={Layers.Overlay}>
        <Overlay {...this.props} />
      </LayerManagerPortal>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onClose() {
    dispatch(removeOverlay());
  },
});

export { OverlayBackground } from './types';

const OverlayContainer: React.ComponentType<OwnProps> = connect(
  undefined,
  mapDispatchToProps,
)(OverlayContainerUnconnected);

const WithProviders: React.ComponentType<OwnProps> = (props) => {
  return (
    <ComponentWrapper>
      <OverlayContainer {...props} />
    </ComponentWrapper>
  );
};

export default WithProviders;
